// extracted by mini-css-extract-plugin
export default {"timer":"TZ-z","loaded":"UZ-z"};